import { array } from 'prop-types';
import React, { useEffect, useRef } from 'react';
const newCssNode = (css, id) => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    head.appendChild(style);
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    style.id = id;
    return style;
};
const PreLoadImages = ({ paths }) => {
    const styleId = useRef(`preload_${String(+new Date())}`);
    const styleRef = useRef();
    const urlPaths = paths.map((p) => `url(${p})`);
    const preLoadCss = `
  body::after {
     position:absolute; width:0; height:0; overflow:hidden; z-index:-1;
     content: ${urlPaths.join(' ')}
  }
  `;
    useEffect(() => {
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLStyleElement' is not assignable to type ... Remove this comment to see the full error message
        styleRef.current = newCssNode(preLoadCss, styleId.current);
        return () => {
            if (styleRef.current) {
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                styleRef.current.remove();
            }
        };
    }, []);
    return React.createElement("div", { hidden: true });
};
PreLoadImages.defaultProps = {
    paths: [],
};
PreLoadImages.propTypes = {
    /** an array of paths to image assets imported by webpack for example */
    paths: array,
};
export default PreLoadImages;
